import { useState } from 'react';
import { useFadeIn } from '@/hooks/useFadeIn';
import { testimonials } from '@/mocks/homeData';

export default function TestimonialsSection() {
  const [current, setCurrent] = useState(0);
  const { ref, isVisible } = useFadeIn(0.1);

  const next = () => setCurrent((prev) => (prev + 1) % testimonials.length);
  const prev = () => setCurrent((prev) => (prev - 1 + testimonials.length) % testimonials.length);

  const t = testimonials[current];

  return (
    <section id="depoimentos" ref={ref} className={`py-20 md:py-28 bg-background-100 fade-section ${isVisible ? 'is-visible' : ''}`}>
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14">
          <span className="text-xs uppercase tracking-[0.2em] text-accent-600 font-semibold mb-3 flex items-center justify-center gap-2">
            <span className="w-2 h-2 rounded-full bg-accent-500 inline-block"></span>
            Depoimentos
          </span>
          <h2 className="font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight max-w-2xl mx-auto">
            Quem confia no nosso trabalho
          </h2>
          <div className="flex items-center justify-center gap-2 mt-4">
            <span className="text-accent-500 text-sm">★★★★★</span>
            <span className="text-foreground-500 text-sm">4.9 · 43 avaliações no Google</span>
          </div>
        </div>

        <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="w-full lg:w-3/5">
            <div className="relative">
              <i className="ri-double-quotes-l text-5xl text-accent-200 mb-6 block"></i>
              <blockquote className="font-heading text-xl md:text-3xl font-medium text-foreground-950 leading-relaxed mb-8 italic">
                "{t.text}"
              </blockquote>

              <div className="flex items-center gap-4 mb-8">
                <div className="w-14 h-14 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img
                    src={t.image}
                    alt={t.name}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div>
                  <p className="font-semibold text-foreground-950 text-sm">{t.name}</p>
                  {t.age && (
                    <p className="text-foreground-500 text-xs">{t.age} anos</p>
                  )}
                  <div className="flex items-center gap-2 mt-1">
                    <span className="text-accent-500 text-xs">★★★★★</span>
                    <span className="text-foreground-400 text-xs">{t.platform}</span>
                  </div>
                </div>
              </div>

              <div className="flex items-center gap-3">
                <button
                  onClick={prev}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:border-accent-500 hover:text-accent-500 transition-all duration-300 cursor-pointer"
                  aria-label="Depoimento anterior"
                >
                  <i className="ri-arrow-left-line"></i>
                </button>
                <button
                  onClick={next}
                  className="w-10 h-10 flex items-center justify-center rounded-full border border-foreground-200 text-foreground-500 hover:border-accent-500 hover:text-accent-500 transition-all duration-300 cursor-pointer"
                  aria-label="Próximo depoimento"
                >
                  <i className="ri-arrow-right-line"></i>
                </button>
                <div className="flex items-center gap-1.5 ml-3">
                  {testimonials.map((_, i) => (
                    <button
                      key={i}
                      onClick={() => setCurrent(i)}
                      className={`w-2 h-2 rounded-full transition-all cursor-pointer ${
                        i === current ? 'bg-accent-500 w-5' : 'bg-foreground-300'
                      }`}
                      aria-label={`Depoimento ${i + 1}`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>
          </div>

          <div className="w-full lg:w-2/5">
            <div className="rounded-2xl overflow-hidden bg-background-200 img-zoom">
              <img
                src={t.image}
                alt={`${t.name} - paciente da Dra. Marihana Pasquali - ${t.procedure}`}
                className="w-full h-auto object-cover object-top aspect-[3/4]"
              />
            </div>
            <p className="text-center text-xs text-foreground-400 mt-3">{t.procedure}</p>
          </div>
        </div>
      </div>
    </section>
  );
}